import React, { useState } from "react";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { Row, Col, Card } from 'antd'
import { Icon } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import Utils from "../Common/Utils.js";
import PatientFunctionsGetter from '../../Controller/getSQLPatientFunctions.js';

const DeviceForm = (props) => {

  let internalSelectedHealthformType

  const get_healthform_name = () => {
    let ret = ""
    if (props.type === "healthform" && props.origin === "update") {
      ret = " (" + props.moduleActivation.name + ")"
    }
    return ret
  }

  const renderHealthformTypesList = () => {
    let healthformTypeList = []
    if (props.origin === "creation") {
      props.moduleActivation.forEach(module => {
        let isHealthform = false
        switch (module.name) {
          case "EQ5D":
            isHealthform = Utils.checkBit(props.features, Utils.featureToBitNumber("healthform_EQ5D"))
            break
          case "SF36":
            isHealthform = Utils.checkBit(props.features, Utils.featureToBitNumber("healthform_SF36"))
            break
          case "MDASI":
            isHealthform = Utils.checkBit(props.features, Utils.featureToBitNumber("healthform_MDASI"))
            break
          case "alimentation":
            isHealthform = Utils.checkBit(props.features, Utils.featureToBitNumber("healthform_ALIMENTATION"))
            break
        }
        if (isHealthform === true && module.used === false) {
          healthformTypeList.push(module.name)
        }
      })
      if (props.selectedHealthformType === "" && healthformTypeList.length > 0) {
        props.setSelectedHealthformType(healthformTypeList[0])
      }
      return (
        <Row style={{width:"100%", display: 'flex'}}>
          <Col style={{width:"14%"}}>
            <FormattedMessage id="healthform.type" defaultMessage="Type" />
          </Col>
          <Col>
            <select id="healthform_type_select" name="healthform_type_select" defaultValue={props.selectedHealthformType} onChange={props.selectHealthformTypeChange} style={{width: "100%", border: "1px solid gray"}}>
              {
                healthformTypeList.map((type,index)=> {
                  return <option value={type} key={index}>{type}</option>
                })
              }
            </select>
          </Col>
        </Row>
      )
    }
    else {
      return (
        null
      )      
    }
  }

  const renderButtons = () => {
    return (
      <div>
        <button onClick={props.cancelPopup} className="btn btn-danger">
          <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
        </button>
        {props.type !== "" ?
          <button onClick={props.checkParametersUpdate} className="btn btn-success" disabled={!props.deviceIdValid}>
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </button>
          :
          null
        }
      </div>
    )
  }

  const renderHealthformAlerts = () => {

    if (props.origin === "creation") {
      internalSelectedHealthformType = props.selectedHealthformType
    }
    else {
      internalSelectedHealthformType = props.moduleActivation.name
    }
    return (
      <div>
        {internalSelectedHealthformType === "EQ5D" ?
          <div>
            {props.renderAlertThresholdAndDelayRow("param.healthformAlert", "Healthform", "healthformAlert", props.handleChangeEq5dChecked, props.handleChangeEq5dThreshold, props.handleChangeEq5dDelay, props.checkedEQ5D, props.this_eq5d_alert, props.handleChangeHealthformThreshold2)}
            {props.renderAlertThresholdAndDelayRow("param.healthformScaleAlert", "Healthform scale", "healthformScaleAlert", props.handleChangeEq5dScaleChecked, props.handleChangeEq5dScaleThreshold, props.handleChangeEq5dScaleDelay, props.checkedEQ5DScale, props.this_eq5d_scale_alert, props.handleChangeHealthformScaleThreshold2)}
          </div>
          :
          null
        }
        {internalSelectedHealthformType === "SF36" ?
          null
          :
          null
        }
        {internalSelectedHealthformType === "MDASI" ?
          props.renderAlertThresholdAndDelayRow("param.healthformAlert", "Healthform", "healthformAlert", props.handleChangeMDASIChecked, props.handleChangeMDASIThreshold, props.handleChangeMDASIDelay, props.checkedMDASI, props.this_mdasi_alert, props.handleChangeHealthformThreshold2)
          :
          null
        }
      </div>
    )
  }

  const generateDevice = () => {
    let add_device = ""
    if (props.origin === "creation") {
      add_device = "_add"
    }

    switch (props.type) {
      case "Tucky":
      case "Tucky_smartphone":
      case "AOJ-20":
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            {props.type === "Tucky_smartphone" ?
              null
              :
              props.renderDeviceSelectRow("device1"+add_device, props.filterTuckyAOJ20(props.device_list, props.type), props.selectedDeviceList.device1.id, props.handleChangeDeviceId, "Tucky", "param.deviceSelectTitle", "ID")
            }
            {props.testThermometerType(props.device_list) ?
              <div style={{fontStyle:"italic"}}>
                {props.renderAlertThresholdAndDelayRow("param.fever", "Fever", "fever_alert", props.handleChangeFeverCheck, props.handleChangeFeverThreshold, props.handleChangeFeverDelay, props.checkedFever, props.this_fever_alert, props.handleChangeFeverThreshold2)}
                {props.type === "Tucky_smartphone" ?
                  null
                  :
                  props.renderReminderForm("tucky_reminder")
                }
              </div>
              :
              <div style={{fontStyle:"italic"}}>
                {props.renderAlertThresholdAndDelayRow("param.fever", "Fever", "fever_alert", props.handleChangeFeverCheck, props.handleChangeFeverThreshold, props.handleChangeFeverDelay, props.checkedFever, props.this_fever_alert, props.handleChangeFeverThreshold2)}
                {props.renderAlertSelectRow("param.position", "Position")}
                {props.renderAlertSwitchRow("param.detach", "Detach", "detach", props.handleChangeDetachCheck, props.checkedDetach)}
                {props.renderAlertSwitchRow("param.battery", "Battery", "battery", props.handleChangeBatteryCheck, props.checkedBattery)}
                {props.type === "Tucky_smartphone" ?
                  null
                  :
                  props.renderReminderForm("tucky_reminder")
                }
              </div>
            }
          </div>
        )
        break
      case "FS20F":
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            {props.renderDeviceSelectRow("device2"+add_device, props.device_list, props.selectedDeviceList.device2.id, props.handleChangeDeviceId, "FS20F", "param.deviceSelectTitle", "ID")}
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {props.renderAlertThresholdAndDelayRow("patientConstants.heartRate", "Pulse Rate", "pulseRateAlert", props.handleChangePRCheck, props.handleChangePRThreshold, props.handleChangePRDelay, props.checkedPR, props.this_PR_alert, props.handleChangePRThreshold2)}
              {props.renderAlertThresholdAndDelayRow("param.spo2Alert", "SPO2", "spo2", props.handleChangeSPO2Check, props.handleChangeSPO2Threshold, props.handleChangeSPO2Delay, props.checkedSPO2, props.this_spo2_alert)}
              {props.renderReminderForm("oximeter_reminder")}
            </div>
          </div>
        )
        break
      case "BP2A":
      case "BPB6":
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            {props.renderDeviceSelectRow("device3"+add_device, props.device_list, props.selectedDeviceList.device3.id, props.handleChangeDeviceId, ["BP2A", "BPB6"], "param.deviceSelectTitle", "ID")}
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {props.renderAlertThresholdAndDelayRow("patientConstants.heartRate", "Pulse Rate2", "pulseRateAlertTension", props.handleChangePRTensionCheck, props.handleChangePRTensionThreshold, props.handleChangePRTensionDelay, props.checkedPRTension, props.this_PR_tension_alert, props.handleChangePRTensionThreshold2)}
              {props.renderAlertThresholdAndDelayRow("param.systolicHighAlert", "Systolic high tension", "systolicHighAlert", props.handleChangeSystolicHighChecked, props.handleChangeSystolicHighThreshold, props.handleChangeSystolicHighDelay, props.checkedSystolicHigh, props.this_sys_high_alert, props.handleChangeSystolicHighThreshold2)}
              {props.renderAlertThresholdAndDelayRow("param.diastolicHighAlert", "Diastolic high tension", "diastolicHighAlert", props.handleChangeDiastolicHighChecked, props.handleChangeDiastolicHighThreshold, props.handleChangeDiastolicHighDelay, props.checkedDiastolicHigh, props.this_dia_alert, props.handleChangeDiastolicHighThreshold2)}
              {props.renderReminderForm("tensiometer_reminder")}
            </div>
          </div>
        )
        break
      case "LESCALE":
      case "S5":
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            {props.renderDeviceSelectRow("device4"+add_device, props.device_list, props.selectedDeviceList.device4.id, props.handleChangeDeviceId, ["LESCALE", "S5"], "param.deviceSelectTitle", "ID")}
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {props.renderAlertThresholdAndDelayRow("param.weightAlert", "Weight", "weight", props.handleChangeWeightChecked, props.handleChangeWeightThreshold, props.handleChangeWeightDelay, props.checkedWeight, props.this_weight_alert, props.handleChangeWeightThreshold2)}
              {props.renderReminderForm("scale_reminder")}
            </div>
          </div>
        )
        break
      case "pain":
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {props.renderAlertThresholdAndDelayRow("param.pain", "Pain", "pain", props.handleChangePainChecked, props.handleChangePainThreshold, props.handleChangePainDelay, props.checkedPain, props.this_pain_alert, props.handleChangePainThreshold2)}
              {props.renderReminderForm("pain_reminder")}
            </div>
          </div>
        )
        break
      case "healthform":
        if (props.origin === "creation") {
          internalSelectedHealthformType = props.selectedHealthformType
        }
        else {
          internalSelectedHealthformType = props.moduleActivation.name
        }
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {renderHealthformTypesList()}
              {renderHealthformAlerts()}
              {props.renderReminderForm("healthform_reminder_"+internalSelectedHealthformType.toLowerCase())}
            </div>
          </div>
        )
        break
      case "niv":
        let niv_list = props.device_list.filter((device) => device.type === "NIV")
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {(niv_list.length > 0) ?
                props.renderDeviceSelectRow("device5"+add_device, props.device_list, props.selectedDeviceList.device5.id, props.handleChangeDeviceId, "NIV", "param.deviceSelectTitle", "ID")
                :
                null
              }
              {props.renderAlertThreshold("patientConstants.VNIusage", "Usage", "breathingObservanceAlert", props.handleChangeBreathingObservanceChecked, props.handleChangeBreathingObservanceThreshold, props.checkedBreathingObservance, props.this_breathing_observance_alert)}
              {props.renderAlertThreshold("param.breathingLeakageAlert", "Leakage", "breathingLeakageAlert", props.handleChangeBreathingLeakageChecked, props.handleChangeBreathingLeakageThreshold, props.checkedBreathingLeakage, props.this_breathing_leakage_alert, props.handleChangeBreathingLeakageThreshold2)}
              {props.renderAlertThreshold("param.breathingLeakage95Alert", "Fuite 95ème", "breathingLeakage95Alert", props.handleChangeBreathingLeakage95Checked, props.handleChangeBreathingLeakage95Threshold, props.checkedBreathingLeakage95, props.this_breathing_leakage95_alert, props.handleChangeBreathingLeakage95Threshold2)}
              {props.renderAlertThreshold("param.breathingAhiAlert", "IAH", "breathingAhiAlert", props.handleChangeBreathingAhiChecked, props.handleChangeBreathingAhiThreshold, props.checkedBreathingAhi, props.this_breathing_ahi_alert, props.handleChangeBreathingAhiThreshold2, {id: "param.breathingAhiAlert.tooltip", defaultMessage: "Indice d'abnées-hypopnées (AHI: Apnea-Hypopnea Index)"})}
              {props.renderAlertThreshold("param.breathingAlert", "Breathing rate", "breathing", props.handleChangeBreathingChecked, props.handleChangeBreathingThreshold, props.checkedBreathing, props.this_breathing_alert, props.handleChangeBreathingThreshold2)}
              {props.renderReminderForm("niv_reminder")}
            </div>
          </div>
        )
        break
      case "oxigen_therapy":
        return (
          <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom:"2%", marginTop:"2%", textAlign:"left" }}>
            <div style={{paddingLeft:"0%", fontStyle:"italic"}}>
              {props.renderAlertThresholdAndDelayRow("param.breathingOxygenRateAlert", "Oxygen rate", "breathingOxygenRateAlert", props.handleChangeBreathingOxygenRateChecked, props.handleChangeBreathingOxygenRateThreshold, props.handleChangeBreathingOxygenRateDelay, props.checkedBreathingOxygenRate, props.this_breathing_oxygen_rate_alert, props.handleChangeBreathingOxygenRateThreshold2)}
              {props.renderReminderForm("oxi_reminder")}
            </div>
          </div>
        )
        break
    }
  }

  return(
    <Card
      title={
        <div style={{"textAlign": "center", paddingLeft:"0px", height: "10px", fontStyle: 'normal'}}>{props.get_device_name(props.device)}{get_healthform_name()}
          {(props.origin === "update" && !(props.type === "niv" && props.nivProvider !== "internal")) ?
            <button id={props.device.id_device} style={{ border:"0px", backgroundColor:"white", position:"absolute", right:10}} onClick={(e) => props.handleClickButtonDelete(e, props.device.type)}>
              <Icon id={props.device.id_device} name='trash' color='grey' style={{margin:"0px"}}/>
            </button>
            :
            null
          }
        </div>
      }
      style={{ height: "100%", paddingBottom:"10px", marginBottom:"2%", overflow: "hidden", borderRadius: "20px", borderColor: "black", width:"100%" }} >
      {generateDevice()}
      {props.origin === "creation" ?
        <div>
          {renderButtons()}
        </div>
        :
        null
      }
    </Card>
    )
}

export default withStyles(Constants.styles)(DeviceForm);
